import React, { useEffect, useState } from 'react';
import '../css/notice.css'
import NoticeBox from './Components/NoticeBox';
import { postAsync } from '../utils/httpClient';

// 공지사항 페이지
const Notice = () => {

  const requestData = {
    limit: "50",
    offset: "0",
  }

  const [noticeList, setNoticeList] = useState([])  // 공지사항 리스트

  // 공지사항 리스트 가져오기
  const getNotcies = async () => {
    await postAsync('/v2/catchNotice/fetchCatchNotice', requestData)
      .then(({ data: noticeListData }) => {
        setNoticeList([...noticeListData.docs])
      })
  }

  // 페이지 로드 완료 후 공지사항 데이터 불러오기
  useEffect(() => {
    getNotcies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="notice">
      <div id="sub_top_warp">
        <div className="sub_top">
          <p className="sub_top_text01">공지사항</p>
        </div>
      </div>
      <div className="noticeContent">
        <div id="noticeTable">
          {noticeList.length === 0 && <span className="emptyListText">공지사항이 없습니다.</span>}
          {
            noticeList.map((noticeData, keyNum) => {
              return (
                <div key={`noticeBox${keyNum}`}>
                  <NoticeBox noticeData={noticeData} />
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  );
}

export default Notice;
